import { CUBE_AGGREGATE_INTERACTION } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { CubeQuery, GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfig } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';
import { EMAIL_CAMPAIGN_FILTER_LIMIT } from '../../filterDefaultLimits';

const EMAIL_CAMPAIGN_OPTIONS: GetOptionsQueryFunction = ({ sourceCube, dateRange }) => {
  const timeDimensions = getDateRangeTimeDimension({
    dateRange,
    dimension: `${CUBE_AGGREGATE_INTERACTION}.interaction_date`,
  });
  const query: CubeQuery = {
    dimensions: [`${sourceCube}.email_name`],
    limit: EMAIL_CAMPAIGN_FILTER_LIMIT,
    filters: [
      { member: `${sourceCube}.channel`, operator: 'equals', values: ['Email'] },
      { member: `${sourceCube}.hcp_bk`, operator: 'set' },
    ],
    timeDimensions: [timeDimensions],
  };
  return query;
};

const emailCampaignFilter: FilterConfig = {
  searchable: true,
  label: 'main.channelFocus.hcpCoverage.filters.emailCampaign.label',
  placeholder: 'main.channelFocus.hcpCoverage.filters.emailCampaign.placeholder',
  clearable: true,
  type: 'multiselect',
  getOptionsQuery: EMAIL_CAMPAIGN_OPTIONS,
  mapResult: mapDimensionToOption(`${CUBE_AGGREGATE_INTERACTION}.email_name`),
  sourceCube: CUBE_AGGREGATE_INTERACTION,
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${CUBE_AGGREGATE_INTERACTION}.email_name`,
      operator: 'equals',
      values: [...v],
    };
  },
  defaultValue: [],
};

export default emailCampaignFilter;
